import { lazy } from "react";
import { PermissionsDispersion } from "./permissions";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/** Rutas */
/**
 * IAM
 */
const DispersionIdex = lazy(() => import("./DispersionIdex"));
const TransferenciaCupo = lazy(() => import("./Views/index"));

const listPermissions = Object.values(PermissionsDispersion);

export const listPermissionsDispersion = listPermissions.splice(
  listPermissions.length / 2
);

const rutasDispersionCupo = {
  link: "/dispersion-cupo",
  label: <AppIcons Logo={"RECAUDO"} name="Transferencia de Cupo" />,
  component: DispersionIdex,
  permission: listPermissionsDispersion,
  subRoutes: [
    {
      link: "/dispersion-cupo/transferencia-cupo",
      label: <AppIcons Logo={"RECAUDO"} name="Transferencia de Cupo" />,
      component: TransferenciaCupo,
      permission: [PermissionsDispersion.transferenciaCupo],
    },
  ],
};

export default rutasDispersionCupo;
